import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  computed,
  input,
  signal,
  ViewEncapsulation,
} from '@angular/core';
import { LocalizedString } from '@cue/api';
import { DeclarativeMapMarkerComponent, DeclarativeMapMarkerTemplateDirective } from '@cue/map/elements';
import { LocalizedStringPipe } from '@cue/utilities';

export interface MapRouteNoteMarker {
  number: number;
  x: number;
  y: number;
  title?: LocalizedString | null;
  description?: LocalizedString | null;
}

@Component({
  selector: 'cue-map-route-note-marker',
  imports: [DeclarativeMapMarkerComponent, DeclarativeMapMarkerTemplateDirective, LocalizedStringPipe],
  templateUrl: './map-route-note-marker.component.html',
  styleUrl: './map-route-note-marker.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class MapRouteNoteMarkerComponent {
  private static openedMarkerNumber = signal<number | null>(null);

  marker = input.required<MapRouteNoteMarker>();
  protected isOpen = computed(() => MapRouteNoteMarkerComponent.openedMarkerNumber() === this.marker().number);

  geoJson = computed(() => ({
    type: 'Point',
    coordinates: [this.marker().x, this.marker().y],
  }));

  @HostListener('document:click')
  protected closeLabel() {
    MapRouteNoteMarkerComponent.openedMarkerNumber.set(null);
  }

  protected toggleLabel(event: MouseEvent) {
    event.stopPropagation();
    MapRouteNoteMarkerComponent.openedMarkerNumber.update((openedMarkerNumber) =>
      openedMarkerNumber === this.marker().number ? null : this.marker().number
    );
  }
}
